export interface IMasterDataProductCategory {
  productCategoryId: number;
  categoryKey: string;
  name: string;
  description: string | null;
  isActive: boolean;
  searchVectorKeywords: string | null;
}

export class MasterDataProductCategory {
  private readonly _productCategoryId: number;
  private readonly _categoryKey: string;
  private readonly _name: string;
  private readonly _description: string | null;
  private readonly _isActive: boolean;
  private readonly _searchVectorKeywords: string | null;

  constructor(props: IMasterDataProductCategory) {
    this._productCategoryId = props.productCategoryId;
    this._categoryKey = props.categoryKey;
    this._name = props.name;
    this._description = props.description;
    this._isActive = props.isActive;
    this._searchVectorKeywords = props.searchVectorKeywords;
  }

  get productCategoryId(): number {
    return this._productCategoryId;
  }
  get categoryKey(): string {
    return this._categoryKey;
  }
  get name(): string {
    return this._name;
  }
  get description(): string | null {
    return this._description;
  }
  get isActive(): boolean {
    return this._isActive;
  }
  get searchVectorKeywords(): string | null {
    return this._searchVectorKeywords;
  }

  static from(props: IMasterDataProductCategory): MasterDataProductCategory {
    return new MasterDataProductCategory(props);
  }

  static toJSON(entity: MasterDataProductCategory): IMasterDataProductCategory {
    return {
      productCategoryId: entity.productCategoryId,
      categoryKey: entity.categoryKey,
      name: entity.name,
      description: entity.description,
      isActive: entity.isActive,
      searchVectorKeywords: entity.searchVectorKeywords,
    };
  }
}
